import en from './languages/en'
import ru from './languages/ru'

export default {
  en,
  ru
}
